export const spacings = {
  xxs: "4px",
  xs: "8px",
  s: "12px",
  m: "16px",
  l: "24px",
  xl: "32px",
  xxl: "48px",
} as const;

export type Spacings = Record<keyof typeof spacings, string> & { raw: typeof spacings };
